import script from "./SmallUnitResult.vue?vue&type=script&setup=true&lang=js"
export * from "./SmallUnitResult.vue?vue&type=script&setup=true&lang=js"

import "./SmallUnitResult.vue?vue&type=style&index=0&id=11ae4f10&lang=css"

const __exports__ = script;

export default __exports__